import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../Navbar/Navbar";
const Home = () => {
	return (
		<>
			<Navbar />
			<div className="home-container">
				<h1>Hi I'm jose Cortez</h1>
				<p className="description">
					Hi, I'm josé a appassionate of technology stuffs, I always trying to
					learning a different topics to improve my tech skills.
				</p>
				<div className="buttons">
					<Link to="/contact/">
						<button className="button hire">I'm looking to hire</button>
					</Link>
					<Link to="/cv/">
						<button className="button button-grey cv">Check my CV</button>
					</Link>
				</div>
			</div>
		</>
	);
};

export default Home;
